import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';
import { hasPartnerDayInRange } from '../logic/ownership';

/**
 * Whether any day at or after `startIndex` is not editable by the current
 * app, per `useTripDesignerConfig().isOwnProduct`. With the default
 * predicate (`() => true`) this is always `false` — TO's behaviour, since it
 * has no ownership concept.
 */
export function useHasPartnerDayInRange(
  days: any[],
  experiencesMap: Record<string, any> | undefined,
): (startIndex: number) => boolean {
  const { isOwnProduct } = useTripDesignerConfig();
  return (startIndex: number) =>
    hasPartnerDayInRange(days, experiencesMap, isOwnProduct, startIndex);
}
